import Home from './pages/Home/Home';
import WhatsAppButton from './components/common/WhatsAppButton/WhatsAppButton';

function App() {
  return (
    <>
      <Home />
      <WhatsAppButton />
    </>
  );
}

export default App;
